module.exports = __webpack_public_path__ + "static/img/user.ad43b88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/user.png
// module id = AGL3
// module chunks = 1